
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 14a7 7 0 117-7 7.008 7.008 0 01-7 7zM7 1.4A5.6 5.6 0 1012.6 7 5.607 5.607 0 007 1.4zm.35 9.8h-.7a.35.35 0 01-.35-.35v-.35a1.4 1.4 0 01-1.4-1.4v-.525a.35.35 0 01.35-.35h.525a.35.35 0 01.35.35v.7h1.75v-.616a.155.155 0 00-.063-.133L5.411 6.545A1.394 1.394 0 014.9 5.467V4.9a1.4 1.4 0 011.4-1.4v-.35a.35.35 0 01.35-.35h.7a.35.35 0 01.35.35v.35a1.4 1.4 0 011.4 1.4v.525a.35.35 0 01-.35.35h-.525a.35.35 0 01-.35-.35v-.7h-1.75v.616a.155.155 0 00.063.133l2.401 1.981A1.394 1.394 0 019.1 8.533V9.1a1.4 1.4 0 01-1.4 1.4v.35a.35.35 0 01-.35.35z"}})])
          )
        }
      }
    